/** 案件 ファイル共有メッセージ：ステータス 下書き */
export const RFP_SHARE_DOCUMENT_MESSAGE_STATUS_DRAFT = {
    label: '下書き保存',
    message: '下書きを保存しました',
    value: 1,
};
/** 案件 ファイル共有メッセージ：ステータス 送信済 */
export const RFP_SHARE_DOCUMENT_MESSAGE_STATUS_PUBLIC = {
    label: '返信',
    message: 'メッセージを送信しました',
    value: 2,
};
